import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';

export type DictationLanguage = 'fr' | 'en';

export interface AgentTranscriptionDto {
  transcript: string;
}

export class AgentApi {
  private axiosInstance: AxiosInstance;
  private basePath: string;

  constructor(configuration: Configuration) {
    this.basePath = configuration.basePath ?? '';
    this.axiosInstance = axios.create({
      baseURL: this.basePath,
      ...configuration.baseOptions,
    });
  }

  async transcribe(
    assetId: string,
    audio: Blob,
    filename: string,
    language: DictationLanguage
  ): Promise<string> {
    const body = new FormData();
    body.append('file', audio, filename);
    body.append('language', language);
    const response = await this.axiosInstance.post<AgentTranscriptionDto>(
      `/assets/${assetId}/agent/transcribe`,
      body
    );
    return response.data.transcript;
  }
}
